import { useEffect, useState } from "react";
import { getNameErrors } from "../helpers/helpers.tsx";
import { getCountries, getHeadquarters, authedFetch } from "../helpers/requests.tsx";
import { useTranslation } from "react-i18next";

const ChangeGroupDataModal = ({
  setShowChangeDataModal,
  groupId,
  groupName,
  groupCountryId,
  groupCountryCode,
  headquarterId,
  showSelectHQ = false,
  handleChangeData,
}) => {
  const [newGroupName, setNewGroupName] = useState("");
  const [newGroupCountryId, setNewGroupCountryId] = useState("");
  const [newGroupCountryCode, setNewGroupCountryCode] = useState("");
  const [newHeadquarterId, setNewHeadquarterId] = useState("");
  const [newHeadquarterName, setNewHeadquarterName] = useState("");

  const [saveDataSubmitted, setSaveDataSubmitted] = useState(false);

  const [countries, setCountries] = useState<any[]>([]);
  const [headquarters, setHeadquarters] = useState<any[]>([]);

  const { t, i18n } = useTranslation();

  useEffect(() => {
    setNewGroupName(groupName);
    setNewGroupCountryId(groupCountryId);
    setNewGroupCountryCode(groupCountryCode);
    setNewHeadquarterId(headquarterId);

    const fetchData = async () => {
      const countryList = await getCountries();
      setCountries(countryList);

      const headquarterList = await getHeadquarters();
      setHeadquarters(headquarterList);
    };

    fetchData();
  }, []);

  const updateGroupData = async (
    groupId: string | null,
    groupName: string,
    groupCountryId: string,
    headquarterId: string
  ) => {
    try {
      await authedFetch(`api/requests/updateGroupData`, {
        method: "POST",
        body: JSON.stringify({
          id: groupId,
          name: groupName,
          country: groupCountryId,
          headquarterId: headquarterId,
        }),
      });
    } catch (error) {
      console.error("Error update group data:", error);
      throw new Error("An error occurred while update group data");
    }
  };

  const handleSaveClick = async () => {
    setSaveDataSubmitted(true);

    if (getNameErrors(newGroupName, t)) return;

    await updateGroupData(
      groupId,
      newGroupName,
      newGroupCountryId,
      newHeadquarterId
    );

    handleChangeData(
      newGroupName,
      newGroupCountryId,
      newGroupCountryCode,
      newHeadquarterId,
      newHeadquarterName
    );
  };

  return (
    <div className="confirmation-modal">
      <div className="modal-content">
        <div style={{ textAlign: "center", fontSize: "1.3em" }}>{t("Edit_Group")}</div>
        <div className="mb-3" style={{ marginTop: "2vh" }}>
          <label
            htmlFor="nameInput"
            style={{
              marginLeft: "20px",
              color: "#404040",
              fontWeight: "bold",
            }}
          >
            {t("Group_Name")}
          </label>
          <input
            type="text"
            id="nameInput"
            className="form-control"
            value={newGroupName}
            onChange={(e) => {
              setNewGroupName(e.target.value);
              setSaveDataSubmitted(false);
            }}
            style={{
              backgroundColor: "#CCCCCC",
              borderRadius: "20px",
              color: "#404040",
              height: "5vh",
              maxHeight: "40px",
              fontSize: "1em",
              paddingLeft: "20px",
            }}
          />
          <label
            htmlFor="nameInput"
            style={{
              marginLeft: "20px",
              color: "#A63939",
              fontSize: "0.8em",
              visibility:
                saveDataSubmitted && getNameErrors(newGroupName, t)
                  ? "visible"
                  : "hidden",
            }}
          >
            {getNameErrors(newGroupName, t)}
          </label>
        </div>

        <div className="mb-3" style={{ marginTop: "2vh" }}>
          <label
            htmlFor="countrySelect"
            style={{
              marginLeft: "20px",
              color: "#404040",
              fontWeight: "bold",
            }}
          >
            {t("Country")}
          </label>
          <select
            id="countrySelect"
            className="form-control"
            style={{
              backgroundColor: "#CCCCCC",
              borderRadius: "20px",
              color: "#404040",
              height: "5vh",
              maxHeight: "40px",
              fontSize: "1em",
              paddingLeft: "20px",
            }}
            value={newGroupCountryId}
            onChange={(e) => {
              const selectedCountryId = e.target.value;
              const selectedCountry = countries.find(
                (country) => country.id === selectedCountryId
              );
              if (selectedCountry) {
                setNewGroupCountryId(selectedCountryId);
                setNewGroupCountryCode(selectedCountry.name);
                setSaveDataSubmitted(false);
              }
            }}
          >
            {countries.map((country: any) => (
              <option key={country.id} value={country.id}>
                {t("country_" + country.code)}
              </option>
            ))}
          </select>
        </div>

        {showSelectHQ && (
          <div className="mb-3" style={{ marginTop: "2vh" }}>
            <label
              htmlFor="headquarterSelect"
              style={{
                marginLeft: "20px",
                color: "#404040",
                fontWeight: "bold",
              }}
            >
              {t("Headquarter")}
            </label>
            <select
              id="headquarterSelect"
              className="form-control"
              style={{
                backgroundColor: "#CCCCCC",
                borderRadius: "20px",
                color: "#404040",
                height: "5vh",
                maxHeight: "40px",
                fontSize: "1em",
                paddingLeft: "20px",
              }}
              value={newHeadquarterId}
              onChange={(e) => {
                const selectedHeadquarterId = e.target.value;
                const selectedHeadquarter = headquarters.find(
                  (headquarter) => headquarter.id === selectedHeadquarterId
                );

                if (selectedHeadquarter || selectedHeadquarterId === "") {
                  setNewHeadquarterId(selectedHeadquarterId);
                  setNewHeadquarterName(
                    selectedHeadquarterId === "" ? "" : selectedHeadquarter.name
                  );
                  setSaveDataSubmitted(false);
                }
              }}
            >
              <option value=""></option>
              {headquarters.map((headquarter: any) => (
                <option key={headquarter.id} value={headquarter.id}>
                  {headquarter.name}
                </option>
              ))}
            </select>
          </div>
        )}

        <div className="button-container">
          <button
            type="button"
            className="buttonCancel btn btn-primary"
            onClick={() => {
              setShowChangeDataModal(false);
              setSaveDataSubmitted(false);
            }}
          >
            {t("Cancel")}
          </button>
          <button
            type="button"
            className="btn btn-primary buttonAcceptGreen"
            onClick={() => handleSaveClick()}
          >
            {t("Save")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ChangeGroupDataModal;
